import { config } from "../../config";
import { client, apiHeaders, request } from "./_base";

const endpoint = "pack";

export type PackType = {
  id: number;
  "Commodity ID": string;
  code: string;
  "No Cartons": number;
  Description: string;
  "Size Table": string;
  "Gross Weight": number;
  "Nett Weight": number;
  "Standard Carton": number;
  Height: number;
  Width: number;
  Depth: number;
  packagingweight: number;
};

export const pack = client(endpoint, (item) => ({
  ...item,
}));

export type PackGenericType = {
  id: number;
  carton: number;
  code: string;
  weight: number;
};
